import { useState, useEffect, useRef } from 'react';
import siteConfigService from './SiteConfigService';

// Poll interval in milliseconds
const POLL_INTERVAL_MS = 60000;

const useSiteConfig = () => {
    const [siteConfig, setSiteConfig] = useState(null);
    const currentConfigRef = useRef(null);
    const hasFetched = useRef(false);

    const [updateAvailable, setUpdateAvailable] = useState(false); // ADDED
    const initialVersionRef = useRef(null); // ADDED

    const dismissUpdate = () => {
        initialVersionRef.current = currentConfigRef.current?.version;
        setUpdateAvailable(false);
    };

    useEffect(() => {
        const poll = async () => {
            try {
                const response = await siteConfigService.getSiteConfig();
                if (!response?.data.data) {
                    return;
                }

                const data = response.data.data;

                // Store initial version on first fetch — ADDED
                if (initialVersionRef.current === null) {
                    initialVersionRef.current = data.version;
                }

                // Check if version changed since first load — ADDED
                if (data.version && data.version !== initialVersionRef.current) {
                    setUpdateAvailable(true); // ADDED
                }

                // Only update state if config changed
                const changed = JSON.stringify(data) !== JSON.stringify(currentConfigRef.current);
                if (changed) {
                    currentConfigRef.current = data;
                    setSiteConfig(data);
                }
            } catch (ex) {
                // Silent fail — do not disrupt site on config fetch failure
                console.log('useSiteConfig');
            }
        };

        if (hasFetched.current) return; // ADDED
        hasFetched.current = true; // ADDED

        poll();
        const interval = setInterval(poll, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    return { siteConfig, updateAvailable, dismissUpdate }; // CHANGED
};

export default useSiteConfig;
